export default __webpack_public_path__ + "static/media/TicTac-Learn-Website_element-19-1.15bbb557.png";